<template>
    <section class="w-full">
        <div class="pda-default">
            <div class="t-headline5">
                {{$t('1646')}}
                <!-- 개인정보 입력 -->
            </div>
            <div class="t-body3 mgt-6 t-color-content1">
                {{$t('1647')}}
                <!-- 비밀번호를 설정하세요. -->
            </div>
            <form @submit.prevent="next()" novalidate>
            <div class="mgt-35">
                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                    :class="submitState && passwordInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="passwordEl"
                >
                    <i class="material-icons mdc-text-field__icon">
                        {{validIcon}}
                    </i>
                    <input type="password" class="mdc-text-field__input"
                        v-model="password"
                        v-validate="'required|min:10|verify_password'"
                        ref="password"
                        id="password"
                        name="password"
                        maxlength="50"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('1648')}}
                            <!-- 비밀번호 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="submitState && passwordInvalidCheck ? 't-color-red1' : ''">
                    <span>{{$t('1649')}}</span>
                </div>
                
               
            </div>

            <div class="mgt-27">
                <button class="mdc-button mdc-button--raised btn-red">
                    {{$t('1650')}}
                    <!-- 다음 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelJoin()" type="button">
                    {{$t('1651')}}
                    <!-- 취소 -->
                </button>
                
            </div>

            </form>
        </div>
        
    </section>
    
</template>

<script>
/**
 * 회원가입 - 패스워드 입력(sign up - input password component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            password: '',
            passwordTextField: null,
            submitState: false,
            validIcon: ''
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
       
        // password 유효성 Check 및 아이콘(validation password & set icon)
        passwordInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('password')) {
                    returnValue = true
                    this.validIcon = 'warning'
                }else {
                    returnValue = false
                    this.validIcon = 'check'
                }
            }

            this.passwordTextField.valid === !returnValue ? '' : this.passwordTextField.valid = !returnValue
            return returnValue
        }

    },

    created() {
        if (!this.join.responsibility || !this.join.terms.TERMS_OF_SERVICE || !this.join.name.first || !this.join.name.last || !this.join.loginId) {
            this.moveJoin2Intro()
        }

    },

    mounted() {
        this.setMaterialUi()
        this.$refs.password.focus()
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('join', ['SET_LOGINPW']),

        setMaterialUi() {
            this.passwordTextField = new MDCTextField(document.querySelector('#passwordEl'))
            this.passwordTextField.useNativeValidation = false
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })

            this.password = this.join.loginPw
            this.passwordTextField.value = this.password
        },

        next() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    this.SET_LOGINPW(this.password)
                    this.$router.push({name: 'Join2Store'})
                } else{
                    this.focusFirstInvalidElement()
                }
            })
        }
    },
}
</script>